import {getMessages} from '../../../../../../../store/constants';

export const ARCHIVE_TITLE = getMessages().getText('card_form_archive_title');
export const UNARCHIVE_TITLE = getMessages().getText('card_form_unarchive_title');
export const UNARCHIVE_TOOLTIP = getMessages().getText('card_form_unarchive_tooltip');
